@if (isDatabasesLoading$ | async) {
  <mat-spinner diameter="24" color="accent"></mat-spinner>
} @else {
  @if (databases$ | async; as databases) {
    <div>
      @if (databases.length > 1) {
        <div>
          <button
            mat-icon-button
            [matTooltip]="'DATABASE_SELECT' | transloco"
            [matMenuTriggerFor]="menu"
            aria-label="Database select"
          >
            <mat-icon>dns</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @for (database of databases; track database) {
              <button
                mat-menu-item
                [routerLink]="['db', database.id]"
                routerLinkActive="active"
              >
                <span>{{
                  database.name | replace: databaseNameReplacement : ' '
                }}</span>
              </button>
            }
          </mat-menu>
        </div>
      }
    </div>
  }
}
